import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import StatisticsForm from "../../../components/schedaCliente/statistics";
import CustomAlert from "../../../components/general/customAlert";
import {
  getKpiList,
  getKpiTitles,
  isBusinessPerformanceActive
} from "../../../store/actions/analytics/index";
import { FormattedMessage } from "react-intl";
import Page from "../../../components/general/page";
import { useIntl } from "react-intl";
import { GetSelectedCompanyStudio } from "../../../libs/companiesUtils";

const StatisticsView = props => {
  const {    
    pageRef
  } = props;

  const dispatch = useDispatch();

  const company = useSelector(state => state.company);
  const user = useSelector(state => state.user);
  const analytics = useSelector(state => state.analytics);
  const companySelected = useSelector(state => state.main.companySelected);

  const [ragioneSociale, setRagioneSociale] = useState(companySelected);

  const studioFind = GetSelectedCompanyStudio();

  const intl = useIntl();

  useEffect(() => {
    dispatch(getKpiList());
    dispatch(getKpiTitles());
    dispatch(isBusinessPerformanceActive());
  }
  , []);

  useEffect(() => {
    if (companySelected) {
      setRagioneSociale(company.companies.find(el => {
        return el.codiceFiscale === companySelected;
      }).ragioneSociale);
    }
  }, [companySelected]);

  const renderBusinessPerformanceToast = () => {
    if (analytics &&
          analytics.isBusinessPerformanceActive &&
          analytics.isBusinessPerformanceActive.status.ended &&
          !analytics.isBusinessPerformanceActive.status.error &&
          !analytics.isBusinessPerformanceActive.isActive) {
      return <CustomAlert        
        msg1="customerPage.landing.alertMsg1"
        msg2="customerPage.landing.alertMsg2"
        buttonText="dashboard.showMore"
        connectionsText="customerPage.landing.connectionsButton"
        isTsPayOnboarding={false}
        isBusinessPerformance={true}
      />
      ;
    }
    return undefined;
  };

  return (
    <Page
      pageRef={pageRef}
      activePage={"/scheda-cliente"}
      className={"contentStructure transparent"}
      title={intl.formatMessage({id: "main.sidebar.businessPerformance"})?.toUpperCase() || "BUSINESS PERFORMANCE"}
      subtitle={ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + companySelected}      
      backText={user?.profile?.language !== "es-ES" ? <FormattedMessage id="deadlines.goClientList" /> : null}
      backUrl={user?.profile?.language !== "es-ES" ? "/scheda-cliente" : null}
      topHeaderContent={studioFind?.taxRegion !== "ES" ? renderBusinessPerformanceToast() : null}

    >
      <StatisticsForm />
    </Page>
  );
};

export default StatisticsView;
